import { Fragment } from "react";
import { Helmet } from 'react-helmet';
import Testing from "../Testing/Testing.jsx";
import FeaturedHome from "../FeaturedHome/FeaturedHome.jsx";
import CustomTitle from "../CustomTitle/CustomTitle.jsx";







export default function Home (){


   return (
      <Fragment>
         <CustomTitle title="الصفحة الرئيسية" />
         <Testing/>
      </Fragment>
   )
} 